import { Component, Input, EventEmitter, Output, Injector, NgZone, ChangeDetectorRef } from '@angular/core';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PatientLayoutComponent } from '../patient-layout/patient-layout.component';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { OpprescriptionService } from 'src/modules/emr/components/op-prescription/opprescription.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { CommonViewerComponent } from 'src/modules/base/components/viewer/common-viewer/common-viewer.component';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AdvanceSearchComponent } from 'src/modules/base/components/advance-search/advance-search.component';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';

@Component({
    selector: 'emr-patient-layout',
    template: `<div [ngStyle]="{'min-height': minHeight  + 'px'}">@if (showBanner && dataForCard.length > 0) {
  <app-patient-layout [dataForCard]="dataForCard" [bannerJson]="bannerJson" (footerLinksClick)="cardFooterLinksClick($event)" (elementInfo)="getHeight($event)"></app-patient-layout>
}</div>
@if (showCoversheet) {
  <app-cover-sheet [data]="event"></app-cover-sheet>
}
@if (!isPrescription) {
  <div dhs-modal></div>
}`,
    styleUrls: ['../patient-layout/patient-layout.component.scss'],
    standalone: false
})

export class EMRPatientLayoutComponent extends PatientLayoutComponent {
  @Input() bannerJson: any;
  @Input() dataForCard: Array<any>;
  @Output() editEllipseClick: EventEmitter<any> = new EventEmitter();
  @Output() footerLinksClick: EventEmitter<any> = new EventEmitter();
  @Input() config: any = {};
  links: any = []
  eventAction: string;
  isPatientVisit: boolean;
  event: any;
  showCoversheet: boolean = false;
  isPrescription: boolean;
  expandCard: boolean = false;
  scrollEvent: any;
  showBanner: boolean;
  minHeight: number = 130;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public alerts: AlertsService,
    public baseService: BaseService,
    public smartModalService: SmartModalService,
    public rolePermissionService: RolePermissionService,
    public communicationService: CommunicationService,
    public opPrescriptionService: OpprescriptionService,
    public preferenceService: PreferenceService,
    public utilService: UtilService,
    public utilitiesService: UtilitiesService,
    public asideService: AsideBarService,
    public ngZone?: NgZone,
    public changeDetectorRef?: ChangeDetectorRef,
    public appService?: AppService,
    public dialogService?: DialogService,
    public authenticationService?: AuthenticationService
  ) {
    super(injector, router, route, alerts, baseService, smartModalService, communicationService, rolePermissionService,preferenceService, utilService)
  }

  onScroll() {
    this.ngZone.runOutsideAngular(() => {

      if (window.scrollY > 100) {
        document.getElementById("core-body").classList.add('fixed-banner')
        this.appService._currentSessionData['fixed_banner'] = true;
      }
      else {
        document.getElementById("core-body").classList.remove('fixed-banner')
        this.appService._currentSessionData['fixed_banner'] = false;
      }
      this.changeDetectorRef.detectChanges();
    })
  }

  ngOnDestroy() {
    if (document.getElementById('core-body') != undefined && document.getElementById('core-body').classList != undefined && document.getElementById('core-body').classList.value != undefined && document.getElementById('core-body').classList.value.includes('fixed-banner')) { document.getElementById("core-body").classList.remove('fixed-banner') };

    this.appService._currentSessionData['fixed_banner'] = false;
    this.scrollEvent.unsubscribe();

    // Clear persisted common viewer pagination map if exists
    const key = 'commonViewerPaginationMap';
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }

  ngOnInit() {
    //debugger;
    this.scrollEvent = this.utilitiesService.documentScrollTarget
      .subscribe(target => this.onScroll());
    if (this.jsonFields.length == 0) {
      this.baseService.getResourceDef(this.bannerJson.jsonName, (resp) => {
        this.bannerJson.resouceDef = resp;       
        
        if (this.route.snapshot.params.hasOwnProperty('action') && this.route.snapshot.params.action == "view") {
          var index = resp.card.fields.findIndex(data => data.name == "link" && data.config != undefined);
          if (index > -1) {
            resp.card.fields[index].config.footerLinks.forEach(element => {
              if (element.redirectLink && element.redirectLink.indexOf('emrView') != -1) {
                if (element.conditions != undefined && !Array.isArray(element.conditions)) {
                  let valid;
                  let item = this.dataForCard[0]; // Dont remove this is used for eval cond check
                  valid = eval(element.conditions.expression)
                  if (valid != undefined && valid != null && valid) {
                    element.label = "Edit EMR";
                    element.redirectLink = "/emr/" + this.route.snapshot.params.key + "/emrDesign";
                  } else {
                    resp.card.fields[index].config.footerLinks.splice(resp.card.fields[index].config.footerLinks.findIndex(data => JSON.stringify(data) === JSON.stringify(element)), 1)
                  }
                } else {
                  element.label = "Edit EMR"
                  element.redirectLink = "/emr/" + this.route.snapshot.params.key + "/emrDesign"
                }
              }
            });
          }
        }
        this.getVitalsList((cb) => {
          this.bannerJson.jsonFields = resp.card;
          this.jsonFields = this.bannerJson.jsonFields.fields.sort((a, b) => { return a.order - b.order });
          this.showBanner = true;
        });
      })
    } else { }
    if (this.bannerJson && this.bannerJson.expandable == undefined) {
      this.bannerJson.expandable = true;
    }
    let link = this.jsonFields.find(val => {
      return val.name == 'link';
    });
    if (link != undefined) {
      if (link.config != undefined) {
        this.addTableClass = true;
      }
    }
    var data = this.dataForCard[0];
    if (this.dataForCard != undefined && this.dataForCard) {
      this.file_id = data.profile_id;
      this.id = data.id;
      this.action = this.route.snapshot.data.action;
      this.resource = this.route.snapshot.data.resource;
      console.log("RESOURCE NAME ::", this.resource);
    }
    //this will show hide coversheet for the tabs
    this.triggerCoversheet();
    if (data && data != undefined) {
      this.getHealthScore(data);
      this.getAllergyData(data);
      this.getComorbidityData(data);
      this.getPastMedicalHistory(data);
      this.getLabData(data);
      // this.checkNotePermission(data);
    }
    if(this.bannerJson && this.bannerJson.datasource && this.bannerJson.datasource.args && this.bannerJson.datasource.args.includes("ivf_no") && this.bannerJson.ivf && this.bannerJson.ivf == true){
      this.getIVFData(this.bannerJson.datasource.args);
    }
  }

  getLabData(data) {
    let params = { args: "uhId:" + data.uhId+",serviceTypeCode:pathology" }
    this.baseService.getData(params, '', 'observation', 'diagnostic', 'GET_CRITICAL_ITEMS_FLAGS').subscribe(
      (res: any) => {
        if (res.errCode == 0 && res.resource.length > 0) {
          this.bannerJson.labData = res.resource;
        }
      });
  }

  getPastMedicalHistory(data) {
    let params = { args: "uhId:" + data.uhId+",only_active:true" }
    params['read_scope_level'] = "account"
    this.baseService.getData(params, '', 'past_medical_history', 'emr', 'GET_PASTMEDICALHISTORY_BY_UHID').subscribe(
      (res: any) => {
        if (res.errCode == 0 && res.resource.length > 0) {
          this.bannerJson.pastMedicalData = res.resource.filter((x) => {
            return ((x.mark_error == undefined || !x.mark_error) && (x.noSignificantHistory == undefined || !x.noSignificantHistory));
          });
          this.bannerJson.pastMedicalData = [...new Map(this.bannerJson.pastMedicalData.map((item) => [(item['illness']), item])).values()];
        }
      });
  }

  getIVFData(args){
    let resourceData ={
      "application": "patient-registration",
      "resource": "ivf_patient",
      "query_id": "GET_PATIENT_BY_IVF_NO",
    }
    
    this.baseService.get(resourceData.query_id, args, resourceData.resource, resourceData.application).subscribe(res => {
      if (res.errCode != -1 && res.resource && res.resource.length > 0) {
        this.bannerJson.IVFData = res.resource;
      }
    });
  }

  checkBannerData(){
      if(this.dataForCard && Array.isArray(this.dataForCard) && this.dataForCard.length>0){
        return this.dataForCard[0];
      }
  }
  getVitalsList(cb) {
    if (this.authenticationService.getUserType() != 'patient') {
      var patient_gender = '';
      var patient_age= "";
      var cardData = sessionStorage.getItem('currentData')?JSON.parse(sessionStorage.getItem('currentData')):this.checkBannerData();
      if (cardData && cardData['patient_gender'] != "does not wish to disclose")
        patient_gender = cardData['patient_gender'] ? cardData['patient_gender'].replace(/ /g, "-") : '';
      else{
        patient_gender = "non-disclose";
      }
        if(cardData && cardData.patient_age){
          patient_age =  cardData.patient_age.replaceAll(",", "/");
        }
      //var patient_age = cardData ? cardData.patient_age.replaceAll(",", "/") : '';
      let resourceData = {
        queryId: 'GET_VITALDEFINITION_BY_FACILITYID',
        args: "patient_gender:" + patient_gender.toLowerCase() + ",patient_age:" + patient_age + "",
        resource: 'vitalDefinition',
        application: 'diagnostic'
      }

      /**
       * calling Service for Data to bind the Vitals
       */
      this.baseService.get(resourceData.queryId, resourceData.args, resourceData.resource, resourceData.application).subscribe(res => {
        if (res.errCode != -1 && res.resource && res.resource.length > 0 && cardData) {
          var filter = "uhId:" + cardData.uhId + ",encounter_id:" + cardData.encounter_id
          this.baseService.get('get_vitals_data_for_banner', '', 'observation_vitals', 'emr', filter).subscribe(vitalsRecord => {
            if (vitalsRecord.errCode != -1 && vitalsRecord.resource && vitalsRecord.resource.length > 0 && vitalsRecord.resource[0].extra_data && JSON.stringify(vitalsRecord.resource[0].extra_data) != '{}') {
              var fields = [];
              res.resource.forEach((vital, index) => {
                var validObj = vitalsRecord.resource[0].vitalsName.filter(x => (x['vitalType'] == vital.vitalType));
                var classValue = this.getClassValue(validObj);
                let obj = {
                  "className": "d-inline-block col-3 mb-1",
                  "heading": vital.vitalType,
                  "field_name": "TextView",
                  "card_tag": "tag" + (index + 1),
                  "order": index + 1,
                  "name": vital.vitalType,
                  "showheading": true,
                  "class": classValue['class'] ? classValue['class']: "",
                  "style": classValue['style'] ? classValue['style'] : ""
                }
                if(vital.poct == true){
                  obj['banner_color_text'] = true,
                  obj['class_conditions']=[
                      {
                          "expression": "true",
                          "class": "poct"
                      }
                  ]
                }
                fields.push(obj)
              });
              fields.push({
                "className": "d-inline-block col-3 mb-1",
                "heading": "Measured at",
                "field_name": "TextView",
                "name": "g_vital_time",
                "type": "datetime",
                "showheading": true
              })
              vitalsRecord.resource[0].extra_data['g_vital_time'] = vitalsRecord.resource[0].vitalsCapturedTime ? vitalsRecord.resource[0].vitalsCapturedTime : vitalsRecord.resource[0].g_creation_time;
              this.dataForCard[0] = { ...this.dataForCard[0], ...vitalsRecord.resource[0].extra_data }
              this.bannerJson['supportingFields'] = { fields: fields, title: 'Vitals'};
              cb(true)
            } else
              cb(true)
          })
        } else
          cb(true)
      }, err => {
        console.error("Api gives Error", err);
      });
    } else
      cb("")
  }

  //get vitals class for banner
  getClassValue(validObj) {
    let obj: object = {};
    if (validObj != undefined && validObj.length != 0 && validObj[0].value != undefined) {
      if (validObj[0].value != '') {
        if (validObj[0].referenceRangeFrom != undefined && validObj[0].referenceRangeTo != undefined && (Number(validObj[0].value) >= validObj[0].referenceRangeFrom && Number(validObj[0].value) <= validObj[0].referenceRangeTo) || validObj[0].referenceRangeFrom == null) {
          obj['class'] = '';
          obj['style'] = '';
        } else {
          if (validObj[0].criticalRangeFrom != undefined && validObj[0].criticalRangeTo != undefined && Number(validObj[0].value) <= validObj[0].criticalRangeFrom || Number(validObj[0].value) >= validObj[0].criticalRangeTo) {
            obj['class'] = "fa fa-flag";
            obj['style'] = 'red';
          }
          else {
            obj['class'] = 'fa fa-exclamation-triangle';
            obj['style'] = '#fcc004';
          }
        }
      } else {
        obj['class'] = '';
        obj['style'] = '';
      }
    } else {
      obj['class'] = '';
      obj['style'] = '';
    }
    return obj;
  }

  getHealthScore(data) {
    let obj = {
      args: "uhId:" + data.uhId
    }
    this.baseService.getData(obj, '', 'observation_template', 'emr', 'GET_LATEST_ASSESSMENT_SCORE').subscribe(
      (res: any) => {
        if (res.errCode == 0 && res.resource && res.resource.length > 0 && (res.resource[0].health_score != undefined || res.resource[0].health_index != undefined)) {
          this.dataForCard[0]['latest_health_score'] = (res.resource[0].health_score != undefined && res.resource[0].health_score != '') ? res.resource[0].health_score : (res.resource[0].health_index != undefined && res.resource[0].health_index != '') ? res.resource[0].health_index : '';
          if (res.resource[0].health_problem_status != undefined && res.resource[0].health_problem_status != '')
            this.dataForCard[0]['latest_health_problem_status'] = res.resource[0].health_problem_status;

          this.baseService.get("GET_TEMPLATE_FORM_BY_ID", "id:" + res.resource[0].template_id, "template", "form-template-engine").subscribe((res: any) => {
            if (res && res.errCode == 0 && res.resource?.length > 0 && res.resource[0].blocks?.length > 0) {
              let finalScoreQuestion = res.resource[0].blocks.find(item =>
                Array.isArray(item.fields) &&
                item.fields.length > 0 &&
                item.fields.some(field => (field.name === 'health_score' || field.name === 'health_index'))
              )?.fields.find(field => (field.name === 'health_score' || field.name === 'health_index'));
              if (finalScoreQuestion?.score_text_mapping?.length > 0) {
                var scoreData = finalScoreQuestion.score_text_mapping;
                for (let i = 0; i < scoreData.length; i++) {
                  if (scoreData[i].operator_key == 'greater_than') {
                    if (this.dataForCard[0]['latest_health_score'] > scoreData[i].operator_value_range1) {
                      console.log('condition 1 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else if (scoreData[i].operator_key == 'less_than') {
                    if (this.dataForCard[0]['latest_health_score'] < scoreData[i].operator_value_range1) {
                      console.log('condition 2 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  } else if (scoreData[i].operator_key == 'is_equal_to') {
                    if (this.dataForCard[0]['latest_health_score'] == scoreData[i].operator_value_range1) {
                      console.log('condition 3 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else if (scoreData[i].operator_key == 'greater_than_or_equal_to') {
                    if (this.dataForCard[0]['latest_health_score'] >= scoreData[i].operator_value_range1) {
                      console.log('condition 4 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else if (scoreData[i].operator_key == 'less_than_or_equal_to') {
                    if (this.dataForCard[0]['latest_health_score'] <= scoreData[i].operator_value_range1) {
                      console.log('condition 5 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else if (scoreData[i].operator_key == 'is_not_equal_to') {
                    if (this.dataForCard[0]['latest_health_score'] != scoreData[i].operator_value_range1) {
                      console.log('condition 6 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else if (scoreData[i].operator_key == 'is_between') {
                    if (this.dataForCard[0]['latest_health_score'] >= scoreData[i].operator_value_range1 && this.dataForCard[0]['latest_health_score'] <= scoreData[i].operator_value_range2) {
                      console.log('condition 7 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else if (scoreData[i].operator_key == 'is_not_between') {
                    if (this.dataForCard[0]['latest_health_score'] <= scoreData[i].operator_value_range1 && this.dataForCard[0]['latest_health_score'] >= scoreData[i].operator_value_range2) {
                      console.log('condition 8 called');
                      this.dataForCard[0]['health_score_color'] = scoreData[i].color_code;
                      break;
                    }
                  }
                  else {
                    console.log('condition 9 called');
                    // do nothing
                  }
                }
              } else {
                console.log('No health score question found');
              }
            }
          });
        }
      });
  }

  getAllergyData(data) {
    let args = "uhId:" + data.uhId;
    this.baseService.get('GET_BY_ALLERGYINTOLERANCE_MAIN', args, 'allergy_intolerance_main', 'emr').subscribe(
      (res: any) => {
        if (res.errCode == 0 && res.resource.length > 0) {
          this.bannerJson.allergyData = res.resource;
          this.bannerJson.allergyData = [...new Map(this.bannerJson.allergyData.map((item) => [(item['substance']), item])).values()];
        }
      });
  }

  // checkNotePermission(data) { //check permission to view patient note from banner
  //   let notePermission = this.rolePermissionService.checkAccessPermission('viewNoteBanner', 'self_note', 'emr')
  //   if(notePermission){
  //     let args = "uhId:" + data.uhId;
  //     this.baseService.get('GET_SELFNOTE_BY_USERID', args, 'self_note', 'emr',"status:Active").subscribe((res: any) => {
  //       if (res.errCode == 0 && res.resource.length > 0)
  //         this.bannerJson.viewNote = {action:"viewNoteBanner"}
  //     });
  //   }
  // }

  getComorbidityData(data) {
    let args = "uhId:" + data.uhId+",type:comorbidity";
    let filter = "type:comorbidity";
    this.baseService.get('GET_COMORBIDITY_DATA_BY_UHID', args, 'familyMemberHistory', 'emr', filter).subscribe(
      (res: any) => {
        if (res.errCode == 0 && res.resource.length > 0) {
          this.bannerJson.comorbidityData = res.resource.filter((x) => {
            return (x.mark_error == undefined || !x.mark_error);
          });
          this.bannerJson.comorbidityData = [...new Map(this.bannerJson.comorbidityData.map((item) => [(item['illness']), item])).values()];
        }
      });
  }
  cardFooterLinksClick(event) {
    event = event.event;
    let argId = '';
    this.getFamilyValidation(event,(res)=> {
      if(res){
        if (this.bannerJson != undefined && this.bannerJson.datasource != undefined && this.bannerJson.datasource.args != undefined) {
          if (this.bannerJson.datasource.args.indexOf('!!!') != -1 && this.bannerJson.datasource.args.split(':')[0] === 'id') {
            argId = this.id;
          } else if (this.bannerJson.datasource.args.split(':')[1] != undefined && this.bannerJson.datasource.args.split(':')[0] === 'id') {
            argId = this.bannerJson.datasource.args.split(':')[1];
          }
        }
        if (this.bannerJson['key'] != undefined) {
          delete this.bannerJson.key;
        }
        if (event.redirectLink != undefined) {
          var bannerData = {
            selector: this.bannerJson.selector,
            datasource: this.bannerJson.datasource,
            component: this.bannerJson.component ? this.bannerJson.component : 'hidden',
            jsonName: this.bannerJson.jsonName
          }
          if(bannerData && this.route.snapshot.queryParams.banner && JSON.parse(this.route.snapshot.queryParams.banner).appt_type){
            bannerData["appt_type"] = "referal"
          }
          let queryParams = {
            banner: JSON.stringify(bannerData),
            returnUrl: this.route.snapshot.queryParams.returnUrl
          }
          if (this.route.snapshot.queryParams.query_params != undefined) {
            bannerData.datasource['args'] = this.route.snapshot.queryParams.query_params
          }
          if (argId != undefined && argId) {
            queryParams['key'] = argId;
          }
          else {
            if ((argId == undefined || argId == "") && this.route.snapshot.queryParams.key != undefined)
              queryParams['key'] = this.route.snapshot.queryParams.key;
            else if (!queryParams['key'] && this.route.snapshot.params && this.route.snapshot.params.id)
              queryParams['key'] = this.route.snapshot.params.id;
            queryParams['query_params'] = this.bannerJson != undefined && this.bannerJson.datasource != undefined && this.bannerJson.datasource.args != undefined ? this.bannerJson.datasource.args : "";
          }
          if(event.redirectLink.includes('!!!')){
            event.redirectLink = event.redirectLink.replace('!!!resource!!!', this.route.snapshot.params.key);
          }
          if(event.label == "View EMR"){
            // added to back navigation for diagnostic 
            if(this.route?.snapshot?.queryParams?.returnUrl.startsWith('/diagnostic/'))
              {
               sessionStorage.setItem("diagnosticbackUrl",this.router.url)
              }
            this.asideService.setCloseSideBAr(false);
          }
          this.router.navigate([event.redirectLink], { queryParams: queryParams });
        } else if (event.redirectLink == undefined && event.action == "showVisits") {
          this.event = event;
          this.showCoversheet = !this.showCoversheet;
          this.asideService.setCloseSideBAr(false);
          this.footerLinksClick.emit({ event });
        } else if (event.redirectLink == undefined && event.action == "viewPrescription") {
          this.viewPrescription();
        } else {
          this.footerLinksClick.emit({ event });
        }
      }
    })
    
  }

  getFamilyValidation(data,cb){
    if(data.label == "View EMR"){
      cb(true)
    }else{
      let item = this.dataForCard[0];
      let args = "uhId:" + item.uhId + ",referenceId:" + item.referenceId + ",encounter_id:"+item.encounter_id;
      this.baseService.get('CHECK_IF_PATIENT_FILE_IS_BLOCKED', args, 'emrpatient', 'emr').subscribe(
        (res: any) => {
          if (res.errCode == 0 && res.resource.length > 0 && !res.resource[0]['valid']) {
            cb(true);
          }else{
            this.alerts.error(res.message);
            cb(false);
          }
        });
    }
  }

  getHeight(event) {
    if (!event.expandCard) {
      this.minHeight = 130;
    }
    else {
      this.minHeight = event.event.scrollHeight + 20;
    }
  }

  // viewNote() { //view patient notes on click from banner
  //   let datasource = {
  //     resource: "self_note",
  //     application: "emr",
  //     args: "uhId:!!!uhId!!!,encounter_id:!!!encounter_id!!!",
  //     filter: "status:Active",
  //     query_id: "GET_SELFNOTE_BY_USERID"
  //   }
  //   let popobj1 = { data: { 'resource': "self_note", 'datasource': datasource}, title: 'Patient Note', size: DialogModalSize.Lg };
  //   this.dialogService.open(AdvanceSearchComponent, popobj1).afterClosed.subscribe(response => {});
  // }

  viewPrescription() {
    this.isPrescription = true;
    let obj = {
      resource: { resource: "prescription_history" },
      bannerJson: this.bannerJson
    }
    let popobj = { data: obj, title: "View Prescription", size: DialogModalSize.XXl };
    this.dialogService.open(CommonViewerComponent, popobj).afterClosed.subscribe(
      response => {
        console.log("response is :: ", response);
        if (response != undefined) {
        }
      });
  }

  triggerCoversheet() {
    //assigning the val  from the observable to show or hide coversheet
    this.opPrescriptionService.coversheetStatus.subscribe((val: boolean) => {
      this.showCoversheet = val;
    });
  }



}

